import './UpgradePlanModal.scss';
export class UpgradePlanModalController {
    static $inject = ['close', 'SegmentService', 'plan', 'logData', 'APPLICATION_DEFAULT_IMAGE', '$window'];
    constructor(close, SegmentService, plan, logData, APPLICATION_DEFAULT_IMAGE, $window) {
        'ngInject';
        this.close = close;
        this.SegmentService = SegmentService;
        this.plan = plan;
        this.logData = logData;
        this.APPLICATION_DEFAULT_IMAGE = APPLICATION_DEFAULT_IMAGE;
        this.$window = $window;
        this.marketplaceSolutionsPackageUpgrade = 'marketplace-solutionspackage-upgrade';
        this.marketplaceSolutionsPackageUpgradeLater = 'marketplace-solutionspackage-upgrade-later';
        this.goUpgrade = async () => {
            this.$window.open('https://digital.take.net/provedora-oficial/', '_blank');
            await this.createTracking(this.marketplaceSolutionsPackageUpgrade, this.logData);
        };
        this.$onInit();
    }
    $onInit() {
        this.isLoading = false;
        this.buttonDisabled = true;
    }
    async closeUpgradePlanModal() {
        await this.createTracking(this.marketplaceSolutionsPackageUpgradeLater, this.logData);
        this.close(false);
    }
    async createTracking(tracking, payload) {
        this.SegmentService.createTrack(tracking, payload);
    }
}
UpgradePlanModalController.$inject = ['close', 'SegmentService', 'plan', 'logData', 'APPLICATION_DEFAULT_IMAGE', '$window'];
